import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentTypeGeneralUse } from './documenttypegeneraluse';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DocumenttypegeneraluseService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<DocumentTypeGeneralUse[]> {
    return this.httpClient.get<DocumentTypeGeneralUse[]>(this.baseUrl + 'api/DocumentTypeGeneralUseApi')
  }
  GetActive(): Observable<DocumentTypeGeneralUse[]> {
    return this.httpClient.get<DocumentTypeGeneralUse[]>(this.baseUrl + 'api/DocumentTypeGeneralUseApi/GetActiveDocumentTypeGeneralUse')
  }
  Post(documenttypegeneraluse: DocumentTypeGeneralUse): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumentTypeGeneralUseApi/add', documenttypegeneraluse, { headers: header, observe: 'response' })
  }
  Delete(documenttypegeneraluse: DocumentTypeGeneralUse) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumentTypeGeneralUseApi/activeordeactive', documenttypegeneraluse, { headers: header, observe: 'response' })
  }
  Put(documenttypegeneraluse: DocumentTypeGeneralUse): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/DocumentTypeGeneralUseApi/Update', documenttypegeneraluse, { headers: header, observe: 'response' })
  }

}
